export interface OwnerInput {
  item: string;
  blocks: string;
}

export const ownerInputs: OwnerInput[] = [
  { item: 'Upload the 96 real JPEGs (not the ZIP/PDF) and return hosted URLs; attach the photo guide .md and master prompt', blocks: 'Real imagery' },
  { item: 'Tampa Local Movers project link (to adapt its components — read-only)', blocks: 'Pattern parity' },
  { item: 'Boundaries of the additional inland Florida area (currently “review”); transportation pricing for corridors and Miami', blocks: 'Automatic booking outside the core area' },
  { item: '20% operating surcharge calculation base', blocks: 'Estimated total and automatic checkout' },
  { item: '20% operating surcharge calculation base, rounding/billing increment, taxes, card-fee eligibility', blocks: 'Final totals' },
  { item: 'Approved packing/materials catalog prices', blocks: 'Packing pricing + savings comparison' },
  { item: 'Approved refund/settlement language (72-hour rule) and prepayment policy', blocks: 'Checkout + prepay' },
  { item: 'Native HighLevel document templates and IDs (booking, deposit, full, third-party, BOL, releases)', blocks: 'Signing' },
  { item: 'HighLevel private integration token + field/pipeline/user IDs (server env only)', blocks: 'CRM' },
  { item: 'A2P 10DLC approval + published workflows + delivery test', blocks: 'SMS' },
  { item: 'Stripe merchant keys + webhook secret (server env only)', blocks: 'Deposit' },
  { item: 'Zelle recipient confirmation in approved account terms', blocks: 'Zelle instructions' },
  { item: 'Meta dataset ID + CAPI token; domain verification', blocks: 'Attribution' },
  { item: 'SmartMoving Lead API key; outreach owner rule', blocks: 'Dual CRM' },
  { item: 'Google Maps keys (browser restricted + server)', blocks: 'Address verification' },
  { item: 'Dispatch availability source', blocks: 'Real slots' },
];

export const connectionOrder = [
  'Upload real photos and map URLs',
  'Deploy backend; set siteConfig.apiBaseUrl',
  'HighLevel lead capture + one follow-up owner; test lead reaches CRM',
  'Publish quote-request version on floridalocalmovers.instamoversfl.com',
  'SmartMoving mirror (transition)',
  'Address validation + service-area rule',
  'Approved surcharge base, contracts and native signing',
  'Stripe sandbox → webhook-verified deposit',
  'Meta browser + CAPI dedup',
  'End-to-end tests, then enable paid booking',
];

export const productionGates = [
  'Real lead capture reaches HighLevel',
  'Approved surcharge base + contract versions',
  'Native signing templates verified',
  'Stripe webhook fulfillment verified',
  'Dispatch availability source',
  'Attribution dedup tested',
];
